import { render } from "./HamburgerMenu.vue?vue&type=template&id=48866a92&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"

import "./HamburgerMenu.vue?vue&type=style&index=0&id=48866a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48866a92"]])

export default __exports__